var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongHuiyuan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 2.912a.667.667 0 01.516-.245h5.524c.206 0 .4.094.527.257l2.942 3.784a.667.667 0 01-.049.875L8.477 13.51a.667.667 0 01-.955 0L1.748 7.592a.667.667 0 01-.04-.887L4.8 2.912z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.667 5.667h1.882L8.177 8l1.568-2.333H11l-3.143 4.782a.235.235 0 01-.425-.08l-.824-3.827h-.941v-.875z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_huiyuan.9fa3f177.svg";
export { SvgTongyongHuiyuan as ReactComponent };